import { Spinner } from "@nextui-org/react";
import PageStaticMetaTags from "@src/components/common/PageStaticMetaTags";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import TextStyles from "../../components/common/TextStyles";
import { SUBSCRIPTION_BILLING_PERIOD_TYPE } from "../../constants";
import usePurchaseOptions from "../../hooks/usePurchaseOptions";
import PlanComparisonTable from "../Subscribe/components/PlanComparisonTable";

export default function PlanComparison() {
  type BillingPeriod = (typeof SUBSCRIPTION_BILLING_PERIOD_TYPE)[keyof typeof SUBSCRIPTION_BILLING_PERIOD_TYPE];

  const { frequency } = useParams<{ frequency?: string }>();
  const { purchaseOptions } = usePurchaseOptions();
  const validFrequencies = new Set<string>(Object.values(SUBSCRIPTION_BILLING_PERIOD_TYPE));
  const selectedFrequency: BillingPeriod =
    frequency && validFrequencies.has(frequency) ? (frequency as BillingPeriod) : SUBSCRIPTION_BILLING_PERIOD_TYPE.MONTHLY;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageStaticMetaTags pageId="planComparison" />
      {!purchaseOptions ? (
        <Spinner className={TextStyles.spinner} />
      ) : (
        <PlanComparisonTable tabledata={purchaseOptions[selectedFrequency]} frequency={selectedFrequency} />
      )}
    </>
  );
}
